import React from 'react'

import MessageItemContainer from '../../containers/messages/message-item-container'
import CreateWorkOrderMessageContainer from '../../containers/messages/create-work-order-message-container'

export default ({
  loading,
  workOrder,
  messages,
  showForm
}) => (
  <div className='list work-order-comments'>
    {loading &&
      <p className='no-content'>Loading...</p>}

    {!loading && showForm &&
      <CreateWorkOrderMessageContainer workOrderId={workOrder.id} />}

    {messages.map((message) =>
      <MessageItemContainer key={message.id} messageId={message.id} />
    )}

    {!loading && messages.length === 0 &&
      <p className='no-content'>There are no messages for this work order.</p>}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/messages/work-order-messages.js